export default __webpack_public_path__ + "static/logo_PARR_pl-26b40b747533e4bb6664a76e3c574bf7.png";